import React from "react";
import { Tag } from "antd";
import { UserRole } from "../util/enums/UserRole.enum";
import { useTranslation } from "react-i18next";

interface UserTagProps {
  role: UserRole;
}

export const UserTag = ({ role }: UserTagProps) => {
  const { t } = useTranslation();

  let tagColor;
  switch (role) {
    case UserRole.OWNER:
      tagColor = "red";
      break;
    case UserRole.USER:
      tagColor = "blue";
      break;
    case UserRole.PENDING:
      tagColor = "orange";
      break;
    default:
      tagColor = "blue";
  }

  return <Tag color={tagColor}>{t(`user-roles.${role}`)}</Tag>;
};
